import { Layout, Spin } from "antd";
import React, { useEffect } from "react";
import { useTranslation, WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { CHECKOUT_STEP, ROUTER_PATH, TOTAL_REQUEST } from "./common/constant";
import Compare from "./components/compare";
import ContactAndShare from "./components/contactAndShare";
import ContactUs from "./components/contactUs";
import Footer from "./components/footer";
import Header from "./components/header";
import Category from "./components/homeCategory";
// import Breadcrumbs from "./components/breadcrumbs";
import { LoadingPage } from "./components/images";
import { selectMenuCategories } from "./redux/reducers/slice/category";
import {
  getGift,
  getGrandOpeningPromotion,
  getHeaderCategories,
  loadCompareProducts,
  loadEventSettings,
  selectGift,
  selectIsLoading,
  setIsLoading,
} from "./redux/reducers/slice/common";
import { actionLoadData } from "./redux/reducers/slice/profile";
import { configAxiosInterceptors } from "./repositories/fetchTools";
import Routes from "./routes";
import PageComingSoon from "./screens/PageComingSoon";

const { Content } = Layout;
interface IProps extends RouteComponentProps<any>, WithTranslation {
  history: any;
}

const App = (props: IProps) => {
  const isLoading = useSelector(selectIsLoading);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isStart, setIsStart] = React.useState(false);
  const slug = props.history.location.pathname.split("/");
  const categories = useSelector(selectMenuCategories);
  const gift = useSelector(selectGift);

  useEffect(() => {
    setIsStart(true);
    configLoadingAxios();
    dispatch(actionLoadData());
    dispatch(loadCompareProducts());
    dispatch(getGrandOpeningPromotion());
    dispatch(loadEventSettings());

    if (!categories) {
      dispatch(getHeaderCategories("619f6226a4b7a308ba0f57e3"));
    }
    if (!gift) {
      dispatch(getGift("60ee9f572971c666c50bcd3d"));
    }
  }, []);

  const configLoadingAxios = () => {
    localStorage.setItem(TOTAL_REQUEST, "0");
    configAxiosInterceptors(
      () => {
        dispatch(setIsLoading(true));
      },
      () => {
        dispatch(setIsLoading(false));
      }
    );
  };

  return isStart ? (
    props.history.location.pathname.includes("/en/") ? (
      <PageComingSoon {...props} />
    ) : (
      <Layout className="kd-layout-wrap">
        <Header {...props} />
        <Content className="kd-layout-content">
          {[
            t(ROUTER_PATH.WARRANTY),
            t(ROUTER_PATH.SIGN_IN),
            t(ROUTER_PATH.SIGN_UP),
            t(ROUTER_PATH.FORGOT_PASSWORD),
            t(ROUTER_PATH.CART),
            t(ROUTER_PATH.PROFILE),
            t(ROUTER_PATH.PROFILE_DETAIL),
            t(ROUTER_PATH.ORDERS),
            t(ROUTER_PATH.ORDER_DETAIL),
            t(ROUTER_PATH.PRODUCTS_WISH),
            `/${t(CHECKOUT_STEP.SHIPPING_INFO)}`,
            `/${t(CHECKOUT_STEP.PAYMENT_METHOD)}`,
          ].includes(`/${slug[slug.length - 1]}`) ? null : (
            <Category {...props} />
          )}

          <Routes {...props} />
        </Content>
        <Compare />
        <ContactUs {...props} />
        <Footer {...props} />

        <ContactAndShare {...props} sectionId="60ee9f572971c666c50bcd3d" />
        <Spin
          className="kd-loading"
          indicator={<img src={LoadingPage} style={{ height: 80, width: "auto" }} />}
          spinning={isLoading}
        />
      </Layout>
    )
  ) : (
    <></>
  );
};

export default withTranslation()(App);
